import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransfersTab } from 'src/app/shared/models/transfers-tab/transfers.tab';
import { ActivatedRoute, Router } from '@angular/router';
import { Currency } from '../../shared/models/currency';
import { StaticValuesUtils } from 'src/app/utils/static-values/static-values.utils';
import {GenericEvent} from "../../models/genericEvent";
import {UpaService} from "../../services/upa/upa.service";
import {AppSettingsService} from "../../services/app-settings/app-settings.service";
import {PriceFormatterPipe} from "../../utils/priceFormatter.pipe";


@Component({
  selector: 'tab-filter',
  templateUrl: './tab-filter.component.html',
  styleUrls: ['./tab-filter.component.scss'],
})
export class TabFilterComponent implements OnInit {

  @Input() tabs: TransfersTab[];
  @Input() currencies: Currency[];
  @Output() tabSelected = new EventEmitter<string>();

  selectedIndex: Number;
  selectedCurrency: string;
  firstIndex: number = 0;
  isMobile: boolean;
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private appSettingsService: AppSettingsService,
    private upaService: UpaService
  ) {}

  ngOnInit() {
    let tabFromUrl = this.getTabFromUrl();
    if (tabFromUrl) {
      this.selectedIndex = this.getIndexOfTab(tabFromUrl);
    } else {
      this.setDefaultIndex();
    }

    this.emitCurrentSelectedTab();
    this.selectedCurrency = this.getCurrencyFromUrl();
    if (!this.selectedCurrency) {
      this.selectedCurrency = this.getSelectedCurrency();
    }
    this.isMobile = StaticValuesUtils.isMobile();
  }


  setActiveTab(index): void {
    this.selectedIndex = index;
    if (this.tabs[index] !== undefined) {
      const name = this.tabs[index].name.toString();
      this.addSelectedTabToUrl(name);
      this.trackUpaTabEvt(index, name);
    }
    this.emitCurrentSelectedTab();

  }

  private setDefaultIndex(): void {
    if (StaticValuesUtils.isHighAndHeavy()) {
      var privateIndex = this.getIndexOfTab('PRIVATE_TRANSFER');
      if (privateIndex !== -1) {
        this.selectedIndex = privateIndex;
      }
    } else {
      //Select the first tab
      this.selectedIndex = this.firstIndex;
    }
  }

  private addSelectedTabToUrl(tab: String): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { selectedTab: tab },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  public getCurrencySymbol(): string {
    return StaticValuesUtils.getCurrencySymbol(this.getSelectedCurrency());
  }

  getSelectedCurrency(): string {
    return this.currencies.find(currency => {
      return currency.selected;
    }).value;
  }

  getMinimumPriceFormatted(price): string {
    let unformattedPriceForCurrentCurrency = price[this.getSelectedCurrency()]
    return new PriceFormatterPipe(this.appSettingsService).transform(unformattedPriceForCurrentCurrency);
  }

  private getTabFromUrl(): string {
    return this.activatedRoute.snapshot.queryParams['selectedTab'];
  }

  private getCurrencyFromUrl(): string {
    return this.activatedRoute.snapshot.queryParams['currency'];
  }

  private getIndexOfTab(tabName): number {
    return this.tabs.findIndex(tab => tab.name === tabName);
  }

  private getTabNameByIndex(index): string {
    return this.tabs[index] !== undefined
      ? this.tabs[index].name
      : "";
  }

  private emitCurrentSelectedTab() {
    this.tabSelected.emit(this.getTabNameByIndex(this.selectedIndex));
  }

  private trackUpaTabEvt(index, name): void {
    this.upaService.track(GenericEvent.newUserAction('changeTab', 'click', {
      channel: this.appSettingsService.getChannel(),
      site: this.appSettingsService.getSite(),
      lang: this.appSettingsService.getLanguage(),
      userId: this.appSettingsService.getUserId(),
      index: index,
      name: name
    }));
  }
}
